import React from 'react'
import styles from './PaginationButton.module.scss'

interface PaginationButtonProps {
  children: React.ReactNode
  onClick: () => void
  active?: boolean
  disabled?: boolean
  className?: never
}

export const PaginationButton: React.FC<PaginationButtonProps> = ({
  children, onClick, active = false, disabled = false,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={[styles.button, active ? styles.active : ''].filter(Boolean).join(' ')}
  >
    {children}
  </button>
)
